import { render, staticRenderFns } from "./manage-dedicated.vue?vue&type=template&id=1396407d&"
import script from "./manage-dedicated.vue?vue&type=script&lang=js&"
export * from "./manage-dedicated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports